export const docInfoEN = {

    "report_id":"Report ID:",

    //Informacije o dokumentu
    "document_information": "Document Information",
    "document_name": "Document name:",
    "report_generation_time": "Report generation time:",
    "num_of_signatures": "Number of eSignatures/eSeals:",
    "report_avalible_on": "Report available on:",
    "report_avalible_until": "Report available until:",
    "signature_status": "Signature status:",
    "signatures_status": "Signatures status:",

    //Potpisi / pečati
    "signatures":"Signatures",
    "signature_seal_id":"Signature/Seal ID:",

    //
    "diagnostic_report":"Validation - Diagnostic report"

}